export const TYPE_OPTIONS = [
  { label: 'All', value: '' },
  { label: 'Article', value: 'article' },
  { label: 'Audio', value: 'audio' },
  { label: 'Video', value: 'video' },
];

export const CONTENT_TAG_OPTIONS = [
  { label: 'All', value: '' },
  {
    label: 'General Lifestyle/Lifestyle Medicine',
    value: 'General Lifestyle/Lifestyle Medicine',
  },
  {
    label: 'General Lifestyle/Nutrition',
    value: 'General Lifestyle/Nutrition',
  },
  { label: 'Diagnosis/Menopause', value: 'Diagnosis/Menopause' },
  {
    label: 'General Lifestyle/Lorem ipsum',
    value: 'General Lifestyle/Lorem ipsum',
  },
];

export const PUBLISH_STATE_OPTIONS = [
  { label: 'All', value: '' },
  { label: 'Draft', value: 'false' },
  { label: 'Published', value: 'true' },
];
